export default "__VITE_ASSET__f578f7b3__"